export function joinPath(a: string, b: string) {
  return a + '/' + b;
}
